<template>
  <div>

    <ul>

      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.gnrl') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.rcvd_mod_loan_req') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxSendPaymentsRequestEmail" @change="switchSendPaymentsRequestEmail" :disabled="canSwitchSendEmail()" :checked="settings.sendPaymentRequestEmail === '1'" v-bind:value="settings.sendPaymentRequestEmail">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" :disabled="canSwitchOcrActivation()" :checked="settings.ocrActivation === '1'" v-bind:value="settings.ocrActivation">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.gnrt_bnk_trnsfr_ordr') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchIsToGenerateXML" :disabled="canSwitchSendPain()" :checked="settings.isToGenerateXML === '1'" v-bind:value="settings.isToGenerateXML">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.vldtn_amnt') }}</label>
            <div class="" style="text-align: right;">{{settings.validationThreshold}}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="150000" value="0" step="500" :disabled="canSwitchValidationThreshold()" v-model="settings.validationThreshold">
          </div>

        </div>

      </div>

    </ul>

    <hr>

    <ul>

      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.pymnt_mthd') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group row">
            <div class="form-group col-sm-auto">
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" id="defaultInline1" type="radio" name="methodRadio" value="application" :disabled="canSwitchPaymentMethod()" v-model="settings.paymentMethod">
                <label class="custom-control-label" for="defaultInline1" :disabled="canSwitchPaymentMethod()">{{ $t('settings.crdt_trnsfr') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" id="defaultInline2" type="radio" name="methodRadio" value="bankCard" :disabled="canSwitchPaymentMethod()" v-model="settings.paymentMethod">
                <label class="custom-control-label" for="defaultInline2" :disabled="canSwitchPaymentMethod()">{{ $t('settings.bnk_crd') }}</label>
              </div>
            </div>
          </div>
        </div>

      </div>

    </ul>

    <!-- <hr>

    <ul>
      <form-accordion open title="NEGOTIATION">
        <div class="form-group" style="margin-inline: initial;">
          <label class="col-form-label">Activate Negotiation</label>
          <label class="label-switch" :class="sliderColorClass">
            <input type="checkbox" class="checkboxNegotiationActivated" v-b-toggle="'collapse-2'" unchecked @change="switchNegotiationActivated" v-bind:value="negotiationActivated">
            <div class="checkbox"></div>
          </label>
        </div>
        <div class="form-group ">
          <b-collapse visible id="collapse-2" class="mt-2">
            <div class="form-group row">
              <div class="col-md-4">
                <label class="col-form-label">Negotiation threshold</label>
              </div>
              <div class="col-sm-auto">
                <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" placeholder="Negotiation threshold" value="">
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label class="col-form-label">Installment number</label>
              </div>
              <div class="col-md-auto">
                <select class="installmentSelect button-setting" v-model="defaultInstallmentNumber">
                  <option v-for="n in 6" :min="1" :value="n">{{n}}</option>
                </select>
              </div>
            </div>
          </b-collapse>
        </div>
      </form-accordion>
    </ul> -->

    <hr>

    <ul>

      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.pymnt_mthd') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.enable_instllment_rules') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxSendPaymentsRequestEmail" :disabled="canSwitchEnableInstallmentRules()" :checked="settings.enableInstallmentRules === '1'" v-model="settings.enableInstallmentRules">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.ngttn_as_dflt') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxSendPaymentsRequestEmail" @change="changeSwitchDefaultNegotiationAllowed" :disabled="canSwitchDefaultNegociationAllowed()" :checked="settings.defaultNegotiationAllowed === '1'" v-bind:value="settings.defaultNegotiationAllowed">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.edit_installments') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxSendPaymentsRequestEmail" :disabled="canSwitchModifInstallments()" :checked="settings.defaultModificationInstallmentsAllowed === '1'" v-model="settings.defaultModificationInstallmentsAllowed">
              <div class="checkbox"></div>
            </label>
          </div>
        </div>

      </div>

    </ul>

  </div>
</template>

<script>
export default {
  props: ['settings'],
  data () {
    return {
      colorBottomButton: this.$engine.firstOn().services.getButtonClassColorById(this.$engine.firstOn().user.currentService.id)
    }
  },
  created () {
  },
  mounted () {
    // expand all menus
    let that = this
    this.Dom7('.accordion-item').addClass('accordion-item-expanded').forEach(item => {
      that.Dom7(item).addClass('accordion-item-expanded')
    })
    this.Dom7('.createInvoiceBand').forEach(item => {
      that.Dom7(item).find('i').transform('rotate(90deg)')
    })
  },
  computed: {
    sliderColorClass () {
      // let fromIdServiceToSliderClass = {
        // '1': 'RTP-slider',
        // '2': 'DD-slider',
        // '6': 'DP-slider'
      // }
      // return fromIdServiceToSliderClass[this.$engine.firstOn().user.currentService.id]
      return 'RTP-slider'
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    switchNegotiationActivated (event) {
      let that = this
      this.negotiationActivated = event.target.checked
      if (this.negotiationActivated) {
        that.Dom7(event.target).parent().parent().parent().parent().parent().parent().next().addClass('accordion-item-expanded')
      } else {
        that.Dom7(event.target).parent().parent().parent().parent().parent().parent().next().removeClass('accordion-item-expanded')
      }
    },
    canSwitchSendEmail () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_send_email', false)
    },
    switchSendPaymentsRequestEmail (obj) {
      this.settings.sendPaymentRequestEmail = obj.target.checked ? '1' : '0'
    },
    switchEnableInstallmentRules (obj) {
      this.settings.enableInstallmentRules = obj.target.checked ? '1' : '0'
    },
    canSwitchDefaultNegociationAllowed () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_nego_allowed', false)
    },
    changeSwitchDefaultNegotiationAllowed (obj) {
      this.settings.defaultNegotiationAllowed = obj.target.checked ? '1' : '0'
    },
    canSwitchOcrActivation () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_ocr_activation', false)
    },
    changeSwitchOcrActivation (obj) {
      this.settings.ocrActivation = obj.target.checked ? '1' : '0'
    },
    canSwitchSendPain () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_generate_pain', false)
    },
    changeSwitchIsToGenerateXML (obj) {
      this.settings.isToGenerateXML = obj.target.checked ? '1' : '0'
    },
    canSwitchValidationThreshold () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_validation_threshold', false)
    },
    canSwitchPaymentMethod () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_payment_method', false)
    },
    canSwitchEnableInstallmentRules () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_installment_rules', false)
    },
    canSwitchModifInstallments () {
      return this.$engine.firstOn().rights.rightIs('ml_settings_unit_modif_installments', false)
    }
  }
}
</script>
<style>
.styleGeneral:hover {
  text-decoration: underline;
  text-decoration-color: #51a45c;
}
</style>
